import React, { useContext, useState, useEffect } from "react";
import DeviceHealthMonitor from "../../components/DeviceHealthMonitor";
import { Navigate } from "react-router-dom";
import EfficiencyMonitor from "../../components/EfficiencyMonitor";
import Tile from "../../components/Tile";
import AIAnalysisCard from "../../components/AIAnalysisCard";
import { gql, useQuery } from "@apollo/client";
import StarekContext from "../../context/StarekContext";
import Spinner from "../../components/Spinner";

function Dashboard(props) {
    const GET_DEVICE_COUNT = gql`
        query GetDashboardMetrics(
            $where: ShadowDeviceWhereInput
            $jobScheduleWhere: JobScheduleWhereInput
            $maintenanceWhere: MaintenanceScheduleWhereInput
        ) {
            aggregateShadowDevice(where: $where) {
                _count {
                    id
                }
            }
            shadowDevices(where: $where) {
                id
                name
                device
                parameters
                jobSchedules {
                    id
                    name
                    start_time
                    end_time
                    part {
                        id
                        name
                        description
                    }
                    cycle {
                        id
                        name
                    }
                }
            }
            aggregateJobSchedule(where: $jobScheduleWhere) {
                _count {
                    id
                }
            }
            aggregateMaintenanceSchedule(where: $maintenanceWhere) {
                _count {
                    id
                }
            }
        }
    `;
    const starekContext = useContext(StarekContext);
    const {
        data: deviceData,
        loading: deviceLoading,
        error: deviceError,
    } = useQuery(GET_DEVICE_COUNT, {
        variables: {
            where: {
                plant: {
                    is: {
                        id: {
                            equals: starekContext.lastUsedPlant?.id,
                        },
                    },
                },
            },
            jobScheduleWhere: {
                plant_id: {
                    equals: starekContext.lastUsedPlant?.id,
                },
            },
            maintenanceWhere: {
                plant_id: {
                    equals: starekContext.lastUsedPlant?.id,
                },
            },
        },
    });

    console.log("Device Data:", deviceData);
    console.log(
        "Maintenance Schedule Count:",
        deviceData?.aggregateMaintenanceSchedule._count.id,
    );
    console.log(
        "Job Schedule Count:",
        deviceData?.aggregateJobSchedule._count.id,
    );
    console.log(
        "Shadow Device Count:",
        deviceData?.aggregateShadowDevice._count.id,
    );

    return (
        <section className="content">
            <div className="container-fluid">
                <div className="row">
                    <Tile
                        type="danger"
                        icon={"fa fa-industry"}
                        header={`10%`}
                        description="Plant Efficiency"
                        linkText="Know Why..."
                        linkNavigateTo="/efficiency-report"
                    ></Tile>
                    <Tile
                        type="warning"
                        header={String(
                            deviceData?.aggregateMaintenanceSchedule._count
                                .id ?? "",
                        )}
                        description="Maintenance Schedules"
                        icon={"fa fa-cogs"}
                        linkText="Know When..."
                        linkNavigateTo="/maintenance"
                    ></Tile>
                    <Tile
                        type="success"
                        header={String(
                            deviceData?.aggregateJobSchedule._count.id ?? "",
                        )}
                        description="Job Schedules Defined"
                        icon={"fa fa-calendar"}
                        linkText="Manage Schedules..."
                        linkNavigateTo="/job-schedules"
                    ></Tile>
                    <Tile
                        type="primary"
                        header={String(
                            deviceData?.aggregateShadowDevice._count.id ?? "",
                        )}
                        description="Bound Devices"
                        icon={"fa fa-microchip"}
                        linkText="Manage Devices..."
                        linkNavigateTo="/devices"
                    ></Tile>
                </div>

                {/* AI Analysis Section */}
                <div className="row mt-3">
                    <div className="col-12">
                        <AIAnalysisCard deviceData={deviceData} />
                    </div>
                </div>

                <div className="row">
                    <section className="col-lg-7 connectedSortable ui-sortable">
                        <EfficiencyMonitor
                            deviceData={deviceData}
                        ></EfficiencyMonitor>
                    </section>
                    <section className="col-lg-5 connectedSortable ui-sortable">
                        {deviceLoading ? (
                            <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ minHeight: "200px" }}
                            >
                                <Spinner />
                            </div>
                        ) : (
                            <DeviceHealthMonitor
                                devices={deviceData?.shadowDevices || []}
                            ></DeviceHealthMonitor>
                        )}
                    </section>
                </div>
            </div>
        </section>
    );
}

export default Dashboard;
